module.exports = __webpack_public_path__ + "static/img/core2.ad376785.png";